import React from "react";

const PageHeading = ({ children }) => (
	<h1 className="mt-4 mb-10 pb-1 inline-block border-b-4 border-primary">
		{children}
	</h1>
);

export default PageHeading;
